/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import type { ExtendedFetchBaseQueryError } from "common/types/ExtendedFetchBaseQueryError";

export enum NotificationMessage {
    BatchNotAvailable = "BatchNotAvailable",
    LateShiftCancellationRequest = "LateShiftCancellationRequest",
    LateAbsenceRequest = "LateAbsenceRequest",
    OverlappingClaim = "overlapping claim",
    ShiftAlreadyClaimedByAnotherDriver = "shift already claimed by another driver",
    ShiftAlreadyClaimedByOtherDriver = "shift already claimed by other driver",
    JWTValidationError = "jwt validation error",
    NoMatchingClaimFlowServiceTags = "no matching claim flow service tags",
    DriverNotAuthenticated = "driver not authenticated",
    DriverNotAuthorized = "driver not authorized",
    DriverInActive = "driver inactive",
    CantUnclaimPastShift = "CANT_UNCLAIM_PAST_SHIFT_ERROR",
    DailyClaimLimitExceeded = "DAILY_CAPACITY_OVER_ERR",
    WeeklyClaimLimitExceeded = "WEEKLY_CAPACITY_OVER_ERR",
    TooManyShiftsPerDay = "TOO_MANY_SHIFTS_PER_DAY_ERR",
    TooManyShiftsPerWeek = "TOO_MANY_SHIFTS_PER_WEEK_ERR",
    TooLittleRestBetweenShifts = "TOO_LITTLE_REST_BETWEEN_SHIFTS",
    MixedDriverVehicle = "MIXED_DRIVER_VEHICLE",
    ErrorGeneral = "ErrorGeneral",
    Logout = "Logout",
    DomainNotAccessible = "domain not accessible",
    DriverNotFound = "driver not found",
    OverlappingAbsenceRequest = "overlapping_absences_error",
    AbsenceDuringOAError = "absence_crud_during_ongoing_global_optimization_error",
    InvalidCode = "invalid code",
    UnsupportedCity = "UNSUPPORTED_CITY",
}

export enum NotificationType {
    ERROR = "error",
    INFO = "info",
    SUCCESS = "success",
    WARNING = "warning",
}

export interface NotificationProps {
    message: string;
    type: NotificationType;
    error?: Error | ExtendedFetchBaseQueryError;
    analyticsContext?: Record<string, string>;
    originalArgs?: any;
}
